/* src/pages/AboutPage.module.css */
.main { padding-top: var(--nav-height); }

.pageHero {
  padding: 5rem 0 4rem; text-align: center;
  background:
    radial-gradient(ellipse 60% 60% at 20% 60%, rgba(61,187,47,0.07) 0%, transparent 65%),
    radial-gradient(ellipse 50% 50% at 80% 30%, rgba(26,127,193,0.08) 0%, transparent 60%),
    var(--dark2);
  border-bottom: 1px solid var(--border);
}
.breadcrumb { display:flex; align-items:center; justify-content:center; gap:0.5rem; font-size:13px; color:var(--muted); margin-bottom:1.5rem; }
.breadcrumb a { color:var(--muted); transition:color var(--transition); }
.breadcrumb a:hover { color:var(--blue-light); }
.breadSep { color:var(--muted2); }
.pageH1 { font-size:clamp(36px,6vw,72px); margin:1.5rem auto 1rem; }
.pageSubtitle { font-size:18px; max-width:560px; margin:0 auto; }

.storyLayout { display:grid; grid-template-columns:1fr 1fr; gap:6rem; align-items:center; }
.storyImg {
  aspect-ratio:3/4; background:var(--card2);
  border:1px dashed var(--border-strong); border-radius:var(--radius-lg);
  display:flex; flex-direction:column; align-items:center; justify-content:center;
  gap:0.75rem; font-size:13px; color:var(--muted); position:relative; overflow:hidden;
}
.storyImg::before {
  content:''; position:absolute; inset:0;
  background:radial-gradient(ellipse 70% 70% at 50% 50%, rgba(26,127,193,0.06) 0%, transparent 70%);
}
.yegBadge {
  position:absolute; bottom:1.5rem; right:1.5rem;
  background:linear-gradient(135deg,var(--blue),var(--green-dark));
  border-radius:var(--radius); padding:1.5rem 2rem;
}
.yegCity { font-family:'Bebas Neue',sans-serif; font-size:42px; letter-spacing:3px; color:#fff; line-height:1; }
.yegSub { font-size:12px; color:rgba(255,255,255,0.7); margin-top:2px; }
.quote {
  border-left:3px solid var(--blue-light); padding:1rem 1.5rem; margin:2rem 0;
  background:var(--blue-pale); border-radius:0 var(--radius) var(--radius) 0;
  font-style:italic; font-size:18px; color:var(--text); line-height:1.6;
}

.valuesSection {
  padding:100px 0; background:var(--dark2);
  border-top:1px solid var(--border); border-bottom:1px solid var(--border);
}
.valuesGrid { display:grid; grid-template-columns:repeat(3,1fr); gap:2rem; }
.valueCard {
  background:var(--card); border:1px solid var(--border);
  border-radius:var(--radius-lg); padding:2.5rem 2rem; text-align:center;
  position:relative; overflow:hidden;
  transition:border-color var(--transition), transform var(--transition);
}
.valueCard:hover { border-color:var(--border-strong); transform:translateY(-4px); }
.valueCard::after {
  content:''; position:absolute; bottom:0; left:0; right:0; height:2px;
  background:linear-gradient(90deg,var(--blue),var(--green));
  opacity:0; transition:opacity var(--transition);
}
.valueCard:hover::after { opacity:1; }

.timeline { max-width:800px; }
.timelineItem { display:grid; grid-template-columns:100px 40px 1fr; gap:0 1.5rem; align-items:start; }
.timelineYear {
  text-align:right; padding-top:3px;
  font-family:'Bebas Neue',sans-serif; font-size:22px; letter-spacing:2px;
}
.timelineCenter { display:flex; flex-direction:column; align-items:center; }
.timelineDot {
  width:16px; height:16px; border-radius:50%;
  border:2px solid var(--blue-light); flex-shrink:0; margin-top:4px;
}
.timelineLine { width:1px; flex:1; min-height:3rem; }
.timelineContent { padding-bottom:2.5rem; }

.videoSection {
  padding:100px 0; background:var(--dark2);
  border-top:1px solid var(--border); border-bottom:1px solid var(--border);
}
.videoLayout { display:grid; grid-template-columns:1.3fr 1fr; gap:5rem; align-items:center; }
.videoBox {
  position:relative; border-radius:var(--radius-lg);
  background:var(--dark3); border:1px solid var(--border); overflow:hidden;
}
.videoTag {
  position:absolute; top:14px; left:14px; z-index:2;
  background:rgba(6,10,15,0.85); backdrop-filter:blur(8px);
  border:1px solid var(--border-strong); border-radius:6px;
  padding:4px 12px; font-size:11px; font-weight:700;
  letter-spacing:1px; text-transform:uppercase; color:var(--blue-light);
}
.videoPlaceholder {
  aspect-ratio:16/9; display:flex; flex-direction:column;
  align-items:center; justify-content:center; gap:1rem;
  background:radial-gradient(ellipse 60% 60% at 50% 50%, rgba(26,127,193,0.07) 0%, transparent 70%);
}
.playBtn {
  width:72px; height:72px; border-radius:50%;
  border:2px solid rgba(63,168,232,0.5);
  display:flex; align-items:center; justify-content:center;
  font-size:28px; color:var(--blue-light); cursor:pointer;
  transition:var(--transition);
}
.playBtn:hover { background:rgba(63,168,232,0.12); border-color:var(--blue-light); transform:scale(1.08); }

.galleryGrid { display:grid; grid-template-columns:repeat(3,1fr); gap:1.25rem; }
.galleryItem { aspect-ratio:4/3; }

.communitySection {
  padding:100px 0; background:var(--dark2); border-top:1px solid var(--border);
}
.communityGrid { display:grid; grid-template-columns:1fr 1fr; gap:1.5rem; }
.communityCard {
  background:var(--card); border:1px solid var(--border);
  border-radius:var(--radius); padding:1.5rem;
  display:flex; gap:1rem;
}

@media (max-width:900px) {
  .storyLayout, .videoLayout { grid-template-columns:1fr; gap:2.5rem; }
  .storyImg { display:none; }
  .valuesGrid { grid-template-columns:1fr 1fr; }
  .communityGrid { grid-template-columns:1fr; }
  .galleryGrid { grid-template-columns:1fr 1fr; }
  .timelineItem { grid-template-columns:80px 30px 1fr; }
}
@media (max-width:600px) {
  .valuesGrid { grid-template-columns:1fr; }
  .galleryGrid { grid-template-columns:1fr; }
}
